// Laravel

// default
// const HMO = null;
// const ABBR = null;
// const ID_NUMBER = null;
// const OPID = null;
// const appURL = null;
// const adminAPI = null;
// const oneProviderAPI = null;
// const vetBypass = null;
// const siloMode = null;

// Development
// const HMO = "Our HMO";
// const ABBR = "HMO";
// const ID_NUMBER = 1; // demo lifeworth
// const OPID = "01HZJXZQ8X9P6K5V4F2W3G7R4M"; // demo lifeworth
// const appURL = "http://127.0.0.1:8000";
// const adminAPI = "http://127.0.0.1:8000/api/admin";
// const oneProviderAPI = "https://demo.tester.api.oneprovider.com.ng/api/admin";
// const oneProviderURL = "https://easy-hmo-provider.web.app";
// const providerAuth = false; // finance, compliance, hod, supervisor
// const clientAuth = false; // finance, compliance, hod, supervisor
// const vetBypass = false; // set true to bypass 1. supervisor, 2. hod, 3. compliance vetting
// const siloMode = true; // set true to disable oneprovider calls
// const claimCap = 5; // set claim cap for demo purposes
// const addManualAuth = false; // set true to allow plain text entry of name and id for admin auth generation

// Demo
const HMO = 'Our HMO';
const ABBR = 'HMO';
const ID_NUMBER = 1; // demo lifeworth
const OPID = '01HZJXZQ8X9P6K5V4F2W3G7R4M'; // demo lifeworth
const appURL = 'https://easyscheme.web.app'; // home
const adminAPI = 'https://api.easyscheme.com.ng/api/admin'; // home
const oneProviderAPI = 'https://demo.tester.api.oneprovider.com.ng/api/admin'; // away
const oneProviderURL = "https://easy-hmo-provider.web.app";
const providerAuth = false; // finance, compliance, hod, supervisor
const clientAuth = false; // finance, compliance, hod, supervisor
const vetBypass = false;
const siloMode = true;
const claimCap = 3;
const addManualAuth = false; // set true to allow plain text entry of name and id for admin auth generation

// LifeWORTH Production
// const HMO = 'LifeWORTH HMO';
// const ABBR = 'LifeWORTH';
// const ID_NUMBER = 1; // live lifeworth
// const OPID = '01J6Y1F5V5GXQZ4KZ1QZ4KZ1T'; // live lifeworth
// const appURL = 'https://lifeworth.easyhmo.com.ng';
// const adminAPI = 'https://api.easyhmo.com.ng/api/admin';
// const oneProviderAPI = 'https://api.oneprovider.com.ng/api/admin';
// const oneProviderURL = "https://oneprovider.web.app";
// const providerAuth = false; // finance, compliance, hod, supervisor
// const clientAuth = false; // finance, compliance, hod, supervisor
// const vetBypass = false;
// const siloMode = true;
// const claimCap = 5;
// const addManualAuth = false; // set true to allow plain text entry of name and id for admin auth generation


// export
export {
  HMO,
  ABBR,
  ID_NUMBER,
  OPID,
  appURL,
  adminAPI,
  oneProviderAPI,
  oneProviderURL,
  providerAuth,
  clientAuth,
  vetBypass,
  siloMode,
  claimCap,
  addManualAuth,
};
